import EDFError from './edf.error';

export default class APIError extends EDFError {
    status?: number;
    target?: string;
    details?: unknown;
    innerError?: unknown;

    constructor(
        message: string,
        code?: string,
        status?: number,
        target?: string,
        details?: unknown,
        innerError?: unknown,
        cause?: Error
    ) {
        const theCode = code || 'EDF:APIError';
        super(message, theCode, cause);
        this.status = status;
        this.target = target;
        this.details = details;
        this.innerError = innerError;
    }

    override toJSON(): {
        name: string;
        message: string;
        code: string;
        status?: number;
        target?: string;
        details?: unknown;
        innerError?: unknown;
    } {
        return {
            name: this.name,
            message: this.message,
            code: this.code,
            status: this.status,
            target: this.target,
            details: this.details,
            innerError: this.innerError,
        };
    }
}
